import { FC, useState } from 'react';
import { getHousingAssociationReport } from '@/api/queries/useHousingAssociationReport';
import { Icon } from '@/components';
import { Icons } from '@/enums';
import strings from '@/language/Swedish';
import styled from 'styled-components';

const StyledIcon = styled(Icon)`
  transform: rotate(45deg);
`;

interface Props {
  ownerId: string | null;
  housingAssociationReportYear: number | null;
}

const HousingAssociationReportCell: FC<Props> = ({ ownerId, housingAssociationReportYear }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [reportUrl, setReportUrl] = useState<string | null>(null);
  
  const year = housingAssociationReportYear || null;

  const handleYearClick = async () => {
    if (!ownerId || !year || isLoading) return;
    
    // If we already have the URL, just open it
    if (reportUrl) {
      window.open(reportUrl, '_blank');
      return;
    }
    
    setIsLoading(true);
    
    try {
      const url = await getHousingAssociationReport(ownerId, year);
      setReportUrl(url);
      // Automatically open the PDF after it's fetched
      window.open(url, '_blank');
    } catch {
    } finally {
      setIsLoading(false);
    }
  };

  if (!year) {
    return null;
  }

  if (isLoading) {
    return <span>{strings.data.loading}...</span>;
  }

  if (reportUrl) {
    return (
      <a
        href={reportUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="flex gap-2 items-center"
      >
        {year}
        <StyledIcon icon={Icons.arrowUp} />
      </a>
    );
  }

  return (
    <a
      onClick={handleYearClick}
      style={{ cursor: 'pointer' }}
      className="flex gap-2 items-center"
    >
      {year}
      <StyledIcon icon={Icons.arrowUp} />
    </a>
  );
};

export default HousingAssociationReportCell;